
export default function Services() {
  return (
    <section className="section-services padding-tb-50" style={{paddingInline:'50px'}}>
      <div className="container">
        <div className="row mb-minus-24">
          <div
            className="col-lg-3 col-md-6 col-12 mb-24"
            // data-aos="flip-up"
            // data-aos-duration={1000}
            // data-aos-delay={200}
          >
            <div className="bb-services-box">
              <div className="services-img">
                <img src="/img/services/1.png" alt="services-1" />
              </div>
              <div className="services-contact">
                <h4>Free Shipping</h4>
                <p>Free shipping on all orders above PKR 6K</p>
              </div>
            </div>
          </div>
          <div
            className="col-lg-3 col-md-6 col-12 mb-24"
            // data-aos="flip-up"
            // data-aos-duration={1000}
            // data-aos-delay={400}
          >
            <div className="bb-services-box">
              <div className="services-img">
                <img src="/img/services/2.png" alt="services-2" />
              </div>
              <div className="services-contact">
                <h4>24x7 Support</h4>
                <p>Contact us 24 hours a day, 7 days a week</p>
              </div>
            </div>
          </div>
          <div
            className="col-lg-3 col-md-6 col-12 mb-24"
            // data-aos="flip-up"
            // data-aos-duration={1000}
            // data-aos-delay={600}
          >
            <div className="bb-services-box">
              <div className="services-img">
                <img src="/img/services/3.png" alt="services-3" />
              </div>
              <div className="services-contact">
                <h4>Fast Delivery</h4>
                <p>Our Delivery partners will deliver at your doorstep</p>
              </div>
            </div>
          </div>
          <div
            className="col-lg-3 col-md-6 col-12 mb-24"
            // data-aos="flip-up"
            // data-aos-duration={1000}
            // data-aos-delay={800}
          >
            <div className="bb-services-box">
              <div className="services-img">
                <img src="/img/services/4.png" alt="services-4" />
              </div>
              <div className="services-contact">
                <h4>Payment Secure</h4>
                <p>Contact us 24 hours a day, 7 days a week</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
